import React from 'react';
import { Row, Col } from '@design-system-etat/dsfr-react';
import InputFiles from 'components/Commun/Form/InputFiles';
import { useFormContext } from 'react-hook-form';
import CertificatMedicalModele from '../../../media/modele_certificat_medical.pdf';

const FormulaireCertificatMedical = () => {
    const hookForm = useFormContext();
    const { formState } = hookForm;

    return (
        <>
            <Row className="margin-top-lg">
                <Col col={12}>
                    <h3>Certificat médical</h3>
                </Col>
            </Row>

            <Row gutters>
                <Col lg={6}>
                    <p>
                        Vous disposez de 3 mois pour importer un certificat médical attestant que
                        votre état de santé physique et psychique n&apos;est pas incompatible avec
                        la détention de ces armes ou munitions. Le modèle proposé ci-dessous doit
                        être rempli et signé par un médecin avant d&apos;être importé dans votre
                        compte SIA.
                    </p>
                    <a href={CertificatMedicalModele} rel="noopener noreferrer" target="_blank">
                        Télécharger le modèle de certificat médical.
                    </a>
                </Col>
                <Col lg={6}>
                    <InputFiles
                        label="Certificat médical"
                        name="certificatMedical"
                        error={formState.errors?.certificatMedical ?? null}
                        message={formState.errors?.certificatMedical?.message}
                    />
                </Col>
            </Row>
        </>
    );
};

export default FormulaireCertificatMedical;
